import { toast } from "react-toastify";

const useToast = () => {
  const toastEmitter = (content, type = null) => {
    switch (type) {
      case "info":
        toast.info(content, {
          autoClose: false,
        });
        break;
      case "success":
        toast.success(content);
        break;
      case "warning":
        toast.warning(content, {
          autoClose: false,
        });
        break;
      case "error":
        toast.error(content, {
          autoClose: false,
        });
        break;
      default:
        toast(content);
        break;
    }
  };

  return toastEmitter;
};

export default useToast;
